
export const SET_MSG = 'NOTAS_MSG';
export const SET_EDITAR = 'NOTAS_EDITAR';
export const SET_LISTA = 'NOTAS_EDITAR';
export const SET_NUMERO = 'NOTAS_NUMERO';